import { useParams, Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { POLICIES } from "@/data/policies";

const Policy = () => {
  const { policyKey } = useParams();
  const policy = POLICIES[policyKey];

  if (!policy) {
    return (
      <div className="bg-cream">
        <div className="max-w-3xl mx-auto px-6 py-24 text-center">
          <h1 className="font-heading font-bold text-3xl text-ink mb-4">Page not found</h1>
          <Link to="/" data-testid="policy-notfound-home-link" className="text-sage font-semibold underline underline-offset-4">Back to Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid={`policy-${policyKey}-page`} className="bg-cream">
      <Seo title={policy.title} path={`/policies/${policyKey}`} />
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-24">
        <p className="text-sm uppercase tracking-widest font-semibold text-gold-dark mb-4">Store policy</p>
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight leading-tight text-ink mb-3">
          {policy.title}
        </h1>
        <p className="text-base text-ink/60 mb-12">Last updated: {policy.updated}</p>
        <div className="space-y-10">
          {policy.sections.map((section) => (
            <section key={section.h}>
              <h2 className="font-heading font-bold text-2xl text-ink mb-3">{section.h}</h2>
              <p className="text-lg leading-relaxed text-ink/80">{section.body}</p>
            </section>
          ))}
        </div>
        <div className="mt-14 bg-white rounded-2xl border border-border p-6">
          <p className="text-base text-ink/75">
            Questions about this policy? Email{" "}
            <a href="mailto:Unstuckbytammi@gmail.com" data-testid="policy-email-link" className="text-sage font-semibold hover:text-sage-dark underline underline-offset-4">
              Unstuckbytammi@gmail.com
            </a>{" "}
            or use our{" "}
            <Link to="/contact" data-testid="policy-contact-link" className="text-sage font-semibold hover:text-sage-dark underline underline-offset-4">
              contact form
            </Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Policy;
